// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.singlefamilyenterprise.properties.RentalManagerUserSingleFamilyEnterprisePropertyV2WebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { RentalManagerUserSingleFamilyEnterprisePropertyV2WebApiHandler_customerId } from '@zg-rentals/ts-rental-manager-api-client';

import type { SingleFamilyEnterprisePropertyCustomerIdRequestDto } from '@zg-rentals/ts-rental-manager-api-client';

export interface RentalManagerUserSingleFamilyEnterprisePropertyV2WebApiHandler_customerId_Args {
  postData: SingleFamilyEnterprisePropertyCustomerIdRequestDto;
}

export type RentalManagerUserSingleFamilyEnterprisePropertyV2WebApiHandler_customerId_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserSingleFamilyEnterprisePropertyV2WebApiHandler_customerId_Args
>;

/**
 * Edit single family enterprise contract customerId for a listing
 */
export const useRentalManagerUserSingleFamilyEnterprisePropertyV2WebApiHandler_customerId = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserSingleFamilyEnterprisePropertyV2WebApiHandler_customerId_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserSingleFamilyEnterprisePropertyV2WebApiHandler_customerId_Args) =>
      RentalManagerUserSingleFamilyEnterprisePropertyV2WebApiHandler_customerId(args.postData, httpClient),
  });
};
